import { Directive } from '@angular/core';
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
} from '@angular/forms';
import { cloneDeep } from 'lodash';

@Directive({
	selector: '[pin-format]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: PinFormattingDirective,
			multi: true,
		},
	],
	standalone: false,
})
export class PinFormattingDirective implements Validator {
	private regexPattern = /^\d{5}-\d{4}$/g;

	validate(control: AbstractControl): ValidationErrors {
		const res =
			cloneDeep(this.regexPattern).test(control.value) || !control.value
				? null
				: { validPin: false };
		return res;
	}
}
